import React from "react";
import PropTypes from "prop-types";
import PaymentPageSubmit from "./PaymentPageSubmit";
import ConnectedRegistrationPageSubmit from "./ConnectedRegistrationPageSubmit";
import ClassificationsPageSubmit from "./ClassificationsPageSubmit";
import StorePageSubmit from "./StorePageSubmit";

const DisplaySubmit = ({ page, ...props }) => {
    const displaySubmit = () => {
        switch (page) {
            case "classification_page":
                return <ClassificationsPageSubmit {...props} />;
            case "details_page":
                return <ConnectedRegistrationPageSubmit {...props} />;
            case "store_page":
                return <StorePageSubmit {...props} />;
            case "checkout_page":
                return <PaymentPageSubmit {...props} />;
            default:
                return <h1>There is no submit component</h1>;
        }
    };

    return <div>{displaySubmit()}</div>;
};

DisplaySubmit.propTypes = {
    page: PropTypes.string.isRequired,
};

export default DisplaySubmit;
